import React from 'react';
import { ListFieldSection } from '../../../../../Layout';
import { Field, NumericInput, TextInput, TextOutput } from '../../../../../Core';
import { WorksheetEquipmentDropdown } from '../../../../Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../../../Core/types';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';

let MassesSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection>
    <WorksheetBalanceFieldSet label="Balance" name="Equipment.WashedBalance" />
    <Field input={<WorksheetEquipmentDropdown />} name="Equipment.WashedOven" label="Oven" equipmentType="oven" />
    <Field input={<TextInput />} name="Masses.InitialTareID" label="Tare ID" maxLength={20} />
    <Field input={<NumericInput />} name="Masses.InitialTareMass" label="Tare Mass" />
    <Field input={<NumericInput />} name="Masses.WashedTareAndDryMass" label={`Tare and Washed Portion Dry Mass`} />
    <Field input={<TextOutput />} name="Masses.WashedDryMass" label={`Washed Portion Dry Mass`} />
  </ListFieldSection>
);

MassesSection = withInjectedProps(MassesSection);

export default MassesSection;
export { MassesSection };
